/**
 * Configuração da integração com a API de simulação/aquisição e URLs de redirect.
 * Valores sensíveis ao ambiente vêm exclusivamente de variáveis VITE_* (.env).
 */

/** Payload fixo enviado em POST de simulação (ids de canal, produto, etc.). */
export const plataformaSimulacao = {
  idCanal: 22,
  situacao: "1",
  idTipoProduto: "1",
  usuarioID: 22749,
  tipoParceiro: 168,
  tipoCanal: 22,
  tipoCanalVendedor: 22,
  idTagCliente: "5",
  idTagNaoCliente: "6",
  idSimuladorTipo: 7,
  dispararSms: true
} as const;

/**
 * Parâmetro `q` (Base64) para GET .../parametro/list (lista de distribuidoras).
 */
export const SIMULACAO_DISTRIBUIDORAS_LIST_Q =
  "ewogICAgIlBhZ2VOdW1iZXIiOiAxLAogICAgIlBhZ2VTaXplIjogOTk5OTk5LAogICAgImZpbHRybyI6IHsKICAgICAgICAiSWRTaW11bGFkb3JUaXBvIjogOAogICAgfQp9";

function trimSlashes(s: string): string {
  return s.replace(/^\/+|\/+$/g, "");
}

/**
 * Primeiro segmento de path da API (ex.: rotas sob `/{prefixo}/simulacao/...`).
 * Definir em `VITE_PLATAFORMA_API_ROUTE_PREFIX` conforme o backend de cada ambiente.
 */
export function getPlataformaApiRoutePrefix(): string {
  const p = import.meta.env.VITE_PLATAFORMA_API_ROUTE_PREFIX?.trim() ?? "";
  if (!p) {
    throw new Error("Defina VITE_PLATAFORMA_API_ROUTE_PREFIX no .env (prefixo das rotas da API de simulação).");
  }
  return trimSlashes(p);
}

/** Nome do campo do token opcional no JSON do POST de simulação (conforme contrato da API do ambiente). */
export function getSimulacaoBodyTokenField(): string {
  const k = import.meta.env.VITE_SIMULACAO_BODY_TOKEN_FIELD?.trim() ?? "";
  if (!k) {
    throw new Error(
      "Defina VITE_SIMULACAO_BODY_TOKEN_FIELD no .env (chave do token no corpo da requisição de simulação)."
    );
  }
  return k;
}

/** URL completa da tela de login da área do cliente (redirect quando lead já cadastrado). */
export function resolvePortalLoginUrl(): string {
  return (import.meta.env.VITE_PORTAL_LOGIN_URL ?? "").trim();
}

/**
 * Origem do portal de aquisição, sem barra final (ex.: https://host/area-cliente).
 */
export function resolvePortalAquisicaoBaseUrl(): string {
  const raw = (import.meta.env.VITE_PORTAL_AQUISICAO_BASE ?? "").trim();
  if (!raw) {
    throw new Error("Defina VITE_PORTAL_AQUISICAO_BASE no .env (base do portal de contratação).");
  }
  return raw.replace(/\/$/, "");
}

/**
 * Caminho após a base até o segmento do hash (ex.: `/thopen/aquisicao`).
 * Sem barra final; pode começar com `/`.
 */
export function getPortalAquisicaoEntryPath(): string {
  const raw = import.meta.env.VITE_PORTAL_AQUISICAO_PATH?.trim() ?? "";
  if (!raw) {
    throw new Error("Defina VITE_PORTAL_AQUISICAO_PATH no .env (caminho da SPA até o fluxo com hash, sem domínio).");
  }
  const normalized = raw.startsWith("/") ? raw : `/${raw}`;
  return normalized.replace(/\/$/, "") || raw;
}

export function getUtmQueryFromLocation(): string | null {
  if (typeof window === "undefined") return null;
  const p = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_id", "utm_term", "utm_content"] as const;
  const parts: string[] = [];
  for (const k of keys) {
    const v = p.get(k);
    if (v) parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  }
  return parts.length ? parts.join("&") : null;
}

export function buildAquisicaoPortalUrl(portalBase: string, hash: string, extraQuery?: string | null): string {
  const base = portalBase.replace(/\/$/, "");
  const entry = getPortalAquisicaoEntryPath();
  const path = `${base}${entry}/${encodeURIComponent(hash)}`;
  return extraQuery ? `${path}?${extraQuery}` : path;
}
